export default class BankAccounts {
  constructor() {
    this.bankAccounts = [];
    this.loaded = false;
  }
}
